import { EventEmitter } from '@angular/core';
import { PlatformLocation } from '@angular/common';
var AppBreakPointComponent = (function () {
    function AppBreakPointComponent(platformLocation) {
        this.platformLocation = platformLocation;
        this.closeAppBreakPoint = new EventEmitter(); //回传标签
        this.isClicked = true;
    }
    AppBreakPointComponent.prototype.ngOnInit = function () {
        console.log(this.userBreakPoint);
        localStorage.setItem("learningPathMetaId", this.userBreakPoint.learningPathMetasId);
        this.courseName = this.userBreakPoint.learningPathMetasName;
        this.courseModule = { 1: '能力诊断', 2: '课程学习', 3: '情景模拟', 4: '能力考核' }[Number(this.userBreakPoint.moduleId)] || '暂无记录';
    };
    AppBreakPointComponent.prototype.ngAfterViewInit = function () {
    };
    //继续学习
    AppBreakPointComponent.prototype.continueLearning = function () {
        if (!this.isClicked) {
            return;
        }
        else {
            var targetUrl = this.userBreakPoint.breakpointUrl;
            // 清除URL中的token和userIdEncoder参数，防止旧token覆盖新token
            targetUrl = this.removeUrlParam(targetUrl, 'token');
            targetUrl = this.removeUrlParam(targetUrl, 'userIdEncoder');
            this.platformLocation['location']['href'] = targetUrl;
            this.isClicked = false;
        }
    };
    AppBreakPointComponent.prototype.removeUrlParam = function (url, param) {
        var urlParts = url.split('?');
        if (urlParts.length >= 2) {
            var prefix = urlParts.shift();
            var queryString = urlParts.join('?');
            var params = queryString.split(/[&;]/g);
            var newParams = [];
            for (var i = 0; i < params.length; i++) {
                var keyValuePair = params[i].split('=');
                if (keyValuePair[0] !== param) {
                    newParams.push(params[i]);
                }
            }
            return prefix + (newParams.length > 0 ? '?' + newParams.join('&') : '');
        }
        return url;
    };
    //关闭
    AppBreakPointComponent.prototype.close = function () {
        if (!this.isClicked) {
            return;
        }
        else {
            this.closeAppBreakPoint.emit();
            this.isClicked = false;
            // 清除项目相关信息
            localStorage.removeItem("projectmsg");
            localStorage.removeItem("projectId");
        }
    };
    return AppBreakPointComponent;
}());
export { AppBreakPointComponent };



// WEBPACK FOOTER //
// ./src/app/app-break-point/app-break-point.component.ts.pre-build-optimizer.js